export default __webpack_public_path__ + "static/imda20182ndprize-63c90045b6498a420def58f05b086ef0.jpg";